//@ts-nocheck

import React from "react";
// import CircleIcon from "@mui/icons-material/Circle";

function LiveIcon() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid #37ae37",
        borderRadius: "10%",
        padding: "4px 5px",
        backgroundColor: "#eafaf4",
        maxWidth: 'fit-content'
      }}
    >
      <span class="flex items-center ml-1 text-[14px] font-semibold text-[#37ae37]">
        <div class="rounded-full w-2 h-2 border border-[#28A745] bg-[#28A745] mr-1"></div>
        Live
      </span>
    </div>
  );
}

function CashIcon() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid #FF5C39",
        padding: "4px 8px",
      }}
    >
      {/* <CircleIcon style={{ color: "#37ae37", fontSize: "8px" }} /> */}
      <span
        style={{
          marginLeft: "4px",
          fontSize: "14px",
          fontWeight: 500,
          color: "#FF5C39",
        }}
      >
        Cash only
      </span>
    </div>
  );
}
function NoBuyerIcon() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid #5EB1BF",
        padding: "4px 8px",
      }}
    >
      {/* <CircleIcon style={{ color: "#37ae37", fontSize: "8px" }} /> */}
      <span
        style={{
          marginLeft: "4px",
          fontSize: "14px",
          fontWeight: 500,
          color: "#5EB1BF",
        }}
      >
        No Buyers Premium
      </span>
    </div>
  );
}
function ReportedIcon() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid #042a2b",
        padding: "4px 8px",
      }}
    >
      {/* <CircleIcon style={{ color: "#37ae37", fontSize: "8px" }} /> */}
      <span
        style={{
          marginLeft: "4px",
          fontSize: "14px",
          fontWeight: 500,
          color: "#042a2b",
        }}
      >
        Reported Vacant
      </span>
    </div>
  );
}
export { CashIcon, LiveIcon, NoBuyerIcon,ReportedIcon };
